module.exports = require('./helpers/bundle-url').getBundleURL('bm7gR') + "logo-dark.eefe0b7f.svg";